import { HFlow, Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'

export default interface ProfissionalHeaderIdentifierDto {
  nomeProfissional: string
  lotacao: any
}

export interface ProfissionalHeaderIdentifierProps {
  profissional: ProfissionalHeaderIdentifierDto
}

export function ProfissionalHeaderIdentifier(props: ProfissionalHeaderIdentifierProps) {
  const { profissional } = props
  return (
    <VFlow vSpacing={0}>
      <Text fontSize={1} fontWeight='bold'>
        {props.profissional.nomeProfissional?.titleCase()}
      </Text>
      <HFlow hSpacing={0.5}>
        <Text fontWeight='bold'>Unidade de saúde</Text>
        <Text>{profissional.lotacao.unidadeSaude.nome?.capitalize()}</Text>
      </HFlow>
      <HFlow hSpacing={0.5}>
        <Text fontWeight='bold'>CBO</Text>
        <Text>
          {profissional.lotacao.cbo.nome?.capitalize()} - {profissional.lotacao.cbo.cbo2002}
        </Text>
      </HFlow>
      <HFlow hSpacing={0.5}>
        <HLabel title='Equipe'>
          {profissional.lotacao.equipe
            ? profissional.lotacao.equipe.nome?.capitalize() + ' - ' + profissional.lotacao.equipe.ine
            : 'Lotação sem equipe'}
        </HLabel>
      </HFlow>
    </VFlow>
  )
}
